import { OwnerRepository } from '../repositories/OwnerRepository';
import { Owner } from '../models/Owner';

export type { Owner };

export class OwnerService {
    static async getOwners() {
        try {
            return await OwnerRepository.getAll();
        } catch (error) {
            console.error('Error fetching owners:', error);
            throw error;
        }
    }

    static async getOwner(id: number) {
        try {
            return await OwnerRepository.getById(id);
        } catch (error) {
            console.error(`Error fetching owner ${id}:`, error);
            throw error;
        }
    }

    static async createOwner(formData: FormData) {
        try {
            return await OwnerRepository.create(formData);
        } catch (error) {
            console.error('Error creating owner:', error);
            throw error;
        }
    }

    static async updateOwner(id: number, data: any) {
        try {
            return await OwnerRepository.update(id, data);
        } catch (error) {
            console.error(`Error updating owner ${id}:`, error);
            throw error;
        }
    }

    static async deleteOwner(id: number) {
        try {
            return await OwnerRepository.delete(id);
        } catch (error) {
            console.error(`Error deleting owner ${id}:`, error);
            throw error;
        }
    }
}
